// extracted by mini-css-extract-plugin
export var wrapper = "sidebar-module--wrapper--28JMc";
export var innerWithForm = "sidebar-module--innerWithForm--RqzUi";
export var title = "sidebar-module--title--2a1ZO";
export var list = "sidebar-module--list--2k+XJ";
export var active = "sidebar-module--active--IVinY";
export var inner = "sidebar-module--inner--+ptgi sidebar-module--innerWithForm--RqzUi";
export var innerPrice = "sidebar-module--innerPrice--44aqA sidebar-module--innerWithForm--RqzUi";
export var listItemSubtitle = "sidebar-module--listItemSubtitle--9ZVFN";
export var listItemPrice = "sidebar-module--listItemPrice--2FMj9";